import {
  type AutocompleteChangeReason,
  type AutocompleteInputChangeReason
} from '@mui/material'
import React, { type FC, type SyntheticEvent } from 'react'
import SearchField from '../../../components/SearchField/SearchField'
import {
  type SearchResult,
  type SearchSchoolDistrictContainerProps
} from '../../../types/types'
import { useLazySearchUniversityQuery } from '../api/universityApi'
import { type University } from '../types/types'

const SearchUniversityContainer: FC<
SearchSchoolDistrictContainerProps<University>
> = ({ onChangeState }) => {
  const [options, setOptions] = React.useState<SearchResult[]>([])

  const [searchUniversity, { isLoading }] =
    useLazySearchUniversityQuery()

  const onFetch = async (
    event: SyntheticEvent<Element, Event>,
    value: string,
    reason: AutocompleteInputChangeReason
  ): Promise<void> => {
    try {
      const newOptions = await searchUniversity(value).unwrap()

      setOptions(newOptions)
    } catch (error) {
      console.error(error)
    }
  }

  const onChagneHandler = (
    event: SyntheticEvent<Element, Event>,
    value: SearchResult | null,
    reason: AutocompleteChangeReason
  ) => {
  
    if (value?.id) {
      onChangeState({ _id: value.id, instnm: value.label })
    }
  }

  return (
    <SearchField
      options={options}
      loading={isLoading}
      handleInputChange={onFetch}
      onChangeHandle={onChagneHandler}
    />
  )
}

export default SearchUniversityContainer
